import React, { Component } from 'react';
import { Divider, Grid, Form, Input, Button, Flag } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { languages } from 'i18n';
import actions from 'actions';
import { api } from 'api';

class ParticipantLogin extends Component {
  constructor(props) {
    super(props);
    this.state = { code: '', participantId: '', password: '', loading: false };
  }
  componentWillMount() {
    const code = localStorage.getItem('trialCode');
    const password = localStorage.getItem('trialPassword');
    if (code) this.setState({ code });
    if (password) this.setState({ password });
  }

  login = () => {
    const { code, participantId, password } = this.state;
    this.setState({ loading: true, errorMessage: '' });
    api.participants.login(code.trim(), participantId.trim(), password, (data) => {
      this.setState({ loading: false });
      this.props.onParticipantLoginSuccess(data.token);
      localStorage.setItem('trialCode', code);
      localStorage.setItem('trialPassword', password);
    }, (err) => {
      this.setState({ loading: false, errorMessage: err.message });
    });
  }

  render() {
    const { t, i18n, participant } = this.props;
    const { loading, errorMessage, code, participantId, password } = this.state;
    if (participant) this.props.history.push('/');
    return (
      <div style={{marginTop: 40}}>
        <Grid stackable centered>
          <Grid.Column computer={6} tablet={8}>
            <h2>{t('participantLogin.title')}</h2>
            <p>{t('participantLogin.description')}</p>
            <Form>
              <Form.Field>
                <label>{t('participantLogin.trialCode')}</label>
                <Input size="huge" fluid type="text" value={code} onChange={e => this.setState({ code: e.target.value })} />
              </Form.Field>
              <Form.Field>
                <label>{t('participantLogin.participantId')}</label>
                <Input size="huge" fluid type="text" value={participantId} onChange={e => this.setState({ participantId: e.target.value })} />
              </Form.Field>
              <Form.Field>
                <label>{t('participantLogin.password')}</label>
                <Input size="huge" fluid type="password" value={password} onChange={e => this.setState({ password: e.target.value })} />
              </Form.Field>
            </Form>
            <div className="ui hidden divider" />
            {errorMessage && (<div className="ui warning message">{errorMessage}</div>)}
            <Button size="huge" color="teal" onClick={this.login} fluid loading={loading}>{t('participantLogin.login')}</Button>

            <Divider hidden />
            <div className='text-center'>
              <h4>{t('changeLanguage')}</h4>
              {languages.map(l =>
                <Button key={l.key} basic active={i18n.language === l.key} onClick={e => i18n.changeLanguage(l.key)}><Flag name={l.flag} /> {l.name}</Button>
              )}
            </div>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { currentParticipantId } = state.participants;
  const participant = state.participants.participants.filter(p => p._id === currentParticipantId)[0];
  return { participant };
};
const mapDispatchToProps = dispatch => ({
  onParticipantLoginSuccess: (token, data) => dispatch(actions.participants.receiveLogin(token, data)),
});

const ParticipantLoginContainer = withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ParticipantLogin)));

export default ParticipantLoginContainer;
